import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ user, signOut, darkMode, setDarkMode }) => {
  const isAdmin = user?.signInUserSession?.accessToken?.payload?.['cognito:groups']?.includes('Admins');

  return (
    <header className="bg-navy-primary text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-gold-primary">
              Navy Football Brotherhood
            </Link>
            <nav className="hidden md:flex space-x-6">
              <Link to="/" className="hover:text-gold-primary transition-colors">Dashboard</Link>
              <Link to="/profile" className="hover:text-gold-primary transition-colors">Profile</Link>
              <Link to="/members" className="hover:text-gold-primary transition-colors">Members</Link>
              <Link to="/seats" className="hover:text-gold-primary transition-colors">Seats</Link>
              {isAdmin && (
                <Link to="/admin" className="hover:text-gold-primary transition-colors">Admin</Link>
              )}
            </nav>
          </div>
          
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="p-2 rounded-lg hover:bg-navy-secondary transition-colors"
            >
              {darkMode ? '☀️' : '🌙'}
            </button>
            <span className="text-sm">Welcome, {user?.signInUserSession?.idToken?.payload?.given_name || user?.attributes?.given_name || user?.username}</span>
            <button
              onClick={signOut}
              className="bg-gold-primary hover:bg-gold-secondary px-4 py-2 rounded-lg transition-colors text-navy-primary font-medium"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;